









































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import * as errorPlugin from "@/components/form/errorValidation";

@Component
export default class CustomInput extends Vue {
  @Prop({ default: true }) showFirstPhoneChar?: boolean;
  @Prop() formType?: string;
  @Prop() minLength?: number;
  @Prop() required?: boolean;
  @Prop() placeholder?: string;
  @Prop() customFormType?: string;
  @Prop({ default: false }) firstSymbolUpperCase?: boolean;
  @Prop({ default: false }) append?: boolean;
  errorMessage!: string | undefined;
  body!: string;
  type: string = "text";
  state: boolean | null = null;
  _required: boolean = false;
  showPassword: boolean = false;
  mask!: any;
  formattedBody!: string | null;

  data() {
    return {
      body: undefined,
      error: undefined,
      errorMessage: undefined,
      mask: undefined,
      formattedBody: undefined
    };
  }

  _change() {
    const LOGIN = "login";
    const PASSWORD = "password";
    const PHONE = "phone";
    const EMAIL = "email";
    this.formattedPhoneBody();

    if (this.formType === LOGIN) {
      if (this.body.length > 2) {
        this.state = true;
      } else if (this.body.length <= 0) {
        this.state = null;
      } else {
        this.state = false;
        this.errorMessage = errorPlugin.minLength(3);
      }
    }

    // if (this.formType === PASSWORD) {
    //   if (this.body.length > 0 && this.body.length <= 5) {
    //     this.state = false;
    //     this.errorMessage = errorPlugin.minLength(6);
    //   } else if (this.body.length <= 0) {
    //     this.state = null;
    //   } else {
    //     let passRegexp = /.*([a-z]+[A-Z]+[0-9]+|[a-z]+[0-9]+[A-Z]+|[A-Z]+[a-z]+[0-9]+|[A-Z]+[0-9]+[a-z]+|[0-9]+[a-z]+[A-Z]+|[0-9]+[A-Z]+[a-z]+).*/;
    //     this.state = passRegexp.test(this.body);
    //     if (!this.state) {
    //       this.errorMessage = errorPlugin.passwordValidate();
    //     }
    //   }
    // }

    if (this.formType === PHONE) {
      this.formattedPhoneBody();
      if (this.formattedBody) {
        if (this.formattedBody.length <= 0) {
          this.state = null;
        } else if (
          this.formattedBody.length > 0 &&
          this.formattedBody.length < 11
        ) {
          this.state = false;
          this.errorMessage = errorPlugin.minLength(11);
        } else if (this.formattedBody.length === 11) {
          this.state = true;
        }
      } else {
        this.state = null;
      }
    }

    if (this.formType === EMAIL) {
      if (this.body.length >= 4) {
        let regex = /\S+@\S+\.\S+/;
        if (this.body.match(regex)) {
          this.state = true;
        } else {
          this.state = false;
          this.errorMessage = this.$tc(this.$translate.IncorrectEmailFormat);
        }
      } else if (this.body.length <= 0) {
        this.state = null;
      } else {
        this.state = false;
        this.errorMessage = errorPlugin.minLength(4);
      }
    }

    if (!this.formType) {
      if (this.body.length > 0) {
        this.state = true;
      } else if (this.body.length <= -1) {
        this.state = null;
      } else {
        this.state = false;
        this.errorMessage = errorPlugin.minLength(1);
      }
    }
  }

  togglePasswordView() {
    this.showPassword = !this.showPassword;
    if (this.formType === "password" && this.showPassword) {
      this.type = "text";
    } else {
      this.type = "password";
    }
  }

  add() {
    this.$emit("add");
  }

  formattedPhoneBody() {
    this.formattedBody = this.body;
    if (this.formType === "phone" && this.formattedBody.length >= 1) {
      let regex = /\w/g;
      if (this.formattedBody.match(regex))
        // @ts-ignore
        this.formattedBody = this.formattedBody.match(regex).join("");
    }
  }

  @Watch("body")
  debounceDelay() {
    if (this.firstSymbolUpperCase) {
      this.body = this.body.charAt(0).toUpperCase() + this.body.slice(1);
    }
    if (this.formType === "phone") {
      this.formattedPhoneBody();
      this.$emit("customChange", this.formattedBody);
    } else {
      this.$emit("customChange", this.body);
    }
  }

  mounted() {
    if (this.required) this._required = this.required;
    if (this.formType === "password") this.type = "password";
    if (this.formType === "phone") {
      this.body = this.showFirstPhoneChar ? "+7" : "";
      this.mask = [
        "+7 ",
        "(",
        /\d/,
        /\d/,
        /\d/,
        ") ",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/
      ];
    }
  }
}
